import axios, { AxiosResponse } from 'axios';

import { IWorldNftTradeResponse } from 'models/store/i-world-nft-trade-response.interface';

export const fetchWorldNftTrade = (): Promise<AxiosResponse<IWorldNftTradeResponse>> => {
  return axios.get<IWorldNftTradeResponse>('/api/v1/trades/world-nft/');
};
